import { Link } from "gatsby"
import React from "react"

const Navigation = () => (
  <nav className="flex flex-col mt-8 mb-5 lg:flex-row lg:justify-evenly">
    <Link to="/" className="text-center" activeClassName="active">
      Home
    </Link>
    <Link to="/endorsements" className="text-center" activeClassName="active" partiallyActive={true}>
      Endorsements
    </Link>
    <Link
      to="/elected-officials"
      className="text-center"
      activeClassName="active"
    >
      Elected Officials
    </Link>
    <Link to="/resolutions" className="text-center" activeClassName="active">
      Resolutions
    </Link>
    <Link to="/videos" className="text-center" activeClassName="active">
      Videos
    </Link>
    {/* <Link
      to="/position-letters"
      className="text-center"
      activeClassName="active"
    >
      Position Letters
    </Link> */}
    {/* <Link to="/faq" className="text-center" activeClassName="active">
      FAQ
    </Link> */}
    <Link to="/map" className="text-center" activeClassName="active">
      Interactive Map
    </Link>
    <Link to="/sb79-vote" className="text-center" activeClassName="active">
      SB79 Vote
    </Link>
    <Link to="/more-info" className="text-center" activeClassName="active">
      More Info
    </Link>
    <Link to="/contact" className="text-center" activeClassName="active">
      Contact
    </Link>
  </nav>
)

export default Navigation
